import React from "react";
import { Circle, CircleCheck, CircleX } from "lucide-react";
import { BillingPaymentStatus } from "@/types/billing-transactions";
import { Badge } from "@/components/ui/badge";
import { PaymentStatus } from "@/types/request";
import { useTranslation } from "react-i18next";

export const PaymentStatusCell = ({
  applyBadge = false,
  paymentStatus,
}: {
  applyBadge?: boolean;
  paymentStatus?: PaymentStatus;
}) => {
  const { t } = useTranslation();

  if (!applyBadge) {
    return (
      <div className="flex items-center justify-center">
        {paymentStatus === BillingPaymentStatus.NOT_REQUIRED && <></>}
        {paymentStatus === BillingPaymentStatus.SUCCEEDED && (
          <CircleCheck color="green" />
        )}
        {paymentStatus === BillingPaymentStatus.PENDING && <Circle />}
        {paymentStatus === BillingPaymentStatus.FAILED && (
          <CircleX color="red" />
        )}
      </div>
    );
  }

  if (paymentStatus === BillingPaymentStatus.NOT_REQUIRED)
    return <Badge variant="outline">{t("billing.statusNotRequired")}</Badge>;
  if (paymentStatus === BillingPaymentStatus.SUCCEEDED)
    return <Badge variant="outline">{t("billing.statusSucceeded")}</Badge>;
  if (paymentStatus === BillingPaymentStatus.REFUNDED)
    return <Badge variant="outline">{t("billing.statusRefunded")}</Badge>;
  if (paymentStatus === BillingPaymentStatus.PARTIALLY_REFUNDED)
    return (
      <Badge variant="outline">{t("billing.statusPartiallyRefunded")}</Badge>
    );

  return <Badge variant="outline">{t("billing.statusNotPaid")}</Badge>;
};
